import { Middleware } from "redux";
import { IState } from "../store/state";
import { PHASE_CHANGE_ON_ACTIVE_CHANNEL, CHANGE_CHANNEL, OVERLAY_SHOW, CAROUSEL_AUTOMODE_START, CAROUSEL_INDEX_CHANGE, CAROUSEL_AUTOMODE_STOP, OVERLAY_HIDE, OVERLAY_TOGGLE, CAROUSEL_MANUALMODE_START, CAROUSEL_MANUALMODE_STOP } from "../actions/actionTypes";
import { getActiveChannelId, getCarouselManualmode, getOverlayVisibility } from "../reducers/gui";
import { getPhaseIdByChannelId } from "../reducers/timings";
import { PHASE_PRE_MATCH, PHASE_POST_MATCH, PHASE_PRE_GAME } from "../api/phases";
import { getConfig } from "../reducers/config";

// TODO actually this doesn't make much sense as a middleware, because the application should react to the current state.

const carouselMiddleware: Middleware = store => next => action => {
    const result = next(action);
    const state = store.getState() as any as IState;
    switch (action.type) {
        case CHANGE_CHANNEL:
        case PHASE_CHANGE_ON_ACTIVE_CHANNEL:
            const manualOverlayMode = getCarouselManualmode(state);
            const layout = getConfig( state ).layout;
            if(!manualOverlayMode  && layout !== "simPlayLayout") {
                const channelId = getActiveChannelId(state);
                const phaseId = getPhaseIdByChannelId(state,channelId);
                
                if(phaseId === PHASE_PRE_MATCH || phaseId === PHASE_PRE_GAME) {
                    store.dispatch({type: OVERLAY_SHOW});
                    store.dispatch({type: CAROUSEL_AUTOMODE_START});
                    switch(phaseId) {
                        case PHASE_PRE_MATCH:
                            store.dispatch({type: CAROUSEL_INDEX_CHANGE, value: 1});
                            break;
                        case PHASE_PRE_GAME:
                        default:
                            store.dispatch({type: CAROUSEL_INDEX_CHANGE, value: 0});
                            break;
                    }
                }

                if(phaseId === PHASE_POST_MATCH) {
                    setTimeout(() => {
                        store.dispatch({type: OVERLAY_SHOW});
                        store.dispatch({type: CAROUSEL_AUTOMODE_START});
                        store.dispatch({type: CAROUSEL_INDEX_CHANGE, value: 0});
                    }, 3000)
                }

                if(phaseId !== PHASE_PRE_MATCH && phaseId !== PHASE_PRE_GAME && phaseId !== PHASE_POST_MATCH) {
                    store.dispatch({type: CAROUSEL_AUTOMODE_STOP});
                    store.dispatch({type: OVERLAY_HIDE});
                    store.dispatch({type: CAROUSEL_INDEX_CHANGE, value: 0});
                }
            }
            break;
        case OVERLAY_TOGGLE:
            const overlayIsVisible = getOverlayVisibility(state);
            if(overlayIsVisible) {
                store.dispatch({type: CAROUSEL_AUTOMODE_STOP});
                store.dispatch({type: CAROUSEL_MANUALMODE_START});
            } else {
                store.dispatch({type: CAROUSEL_MANUALMODE_STOP});
                store.dispatch({type: CAROUSEL_AUTOMODE_START});
            }
            break;
    }
    return result;
}

export default carouselMiddleware;